import { create } from 'zustand'
import { persist, createJSONStorage, devtools } from 'zustand/middleware'

// This boilerplate enables devtools and ensures the store is saved in local storage (to enable data to persist between tabs and sessions). This is imported to other stores so it can be edited in one place and minimise boilerplate code

const allStores = []

export const storeWrapper = (storeName, properties) => {
  const store = create(
    devtools(
      persist(properties, {
        name: storeName,
        storage: createJSONStorage(() => localStorage) // (optional) by default, 'localStorage' is used
      }),
      { name: 'os-store', store: storeName }
    )
  )

  allStores.push(store)
  return store
}

export const performStoreLifecycleAction = ({ action }) => {
  allStores.forEach((store) => {
    const state = store.getState()
    const fn = state ? state[action] : null
    if (fn) fn()
  })
}
